import { render, staticRenderFns } from "./DashboardOfDistributor.vue?vue&type=template&id=67c8da5e&scoped=true"
import script from "./DashboardOfDistributor.vue?vue&type=script&lang=js"
export * from "./DashboardOfDistributor.vue?vue&type=script&lang=js"
import style0 from "./DashboardOfDistributor.vue?vue&type=style&index=0&id=67c8da5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8da5e",
  null
  
)

export default component.exports